export const isModifiedEvent = event => !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
export const isKeyboardEvent = event => ['keypress', 'keydown', 'keyup'].includes(event.type);